import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import { combineReducers } from "redux";

import basicInfo from "./slices/basicInfo";
import chat from "./slices/chat";
import modal from "./slices/modal";
import chat_ui from './slices/chatUi'
import authAnimation from './slices/authAnimation';
import progessingRequest from './slices/progessingRequest';
import notification from './slices/notification';
import order from './slices/order';
import withdraw from './slices/withdraw';
import Dispute from './slices/Dispute';
import DeliveryImage from './slices/deliveryImage';
import favorite from './slices/favorite';
import carrierPosition from './slices/carrierPosition'

const reducer = combineReducers({
  basicInfo,
  chat,
  modal,
  chat_ui,
  authAnimation,
  progessingRequest,
  notification,
  order,
  withdraw,
  Dispute,
  DeliveryImage,
  favorite,
  carrierPosition
});

const store = configureStore({
  reducer,
  middleware: getDefaultMiddleware({
    serializableCheck: false,
  }),
});

export default store;
